import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ palette, typography, customShadows, spacing, breakpoints }) => ({
    root: {
      [breakpoints.down('sm')]: {
        width: '100%'
      },
      minWidth: 170,
      maxHeight: 40,
      padding: '10px 14px',
      backgroundColor: palette.common.white,
      color: palette.grey.shade[70],
      boxSizing: 'border-box',
      border: ({ open }) =>
        open
          ? `2px solid ${palette.primary.main}`
          : `1px solid ${palette.grey.shade[50]}`,
      '&.MuiButton-root:hover': {
        backgroundColor: palette.common.white
      }
    },
    label: {
      justifyContent: 'space-between',
      ...typography.body1
    },
    apply: {
      width: 143
    },
    fixed: {
      width: '100%',
      padding: '10px 8px',
      backgroundColor: palette.white.main,
      position: 'sticky',
      bottom: 0
    },
    popover: {
      marginTop: 7,
      boxSizing: 'border-box',
      border: `1px solid ${palette.grey.shade[10]}`,
      backgroundColor: palette.white.main,
      boxShadow: customShadows.l,
      padding: 0,
      [breakpoints.down('sm')]: {
        width: 'calc(100% - 58px)'
        // width: '100%'
        // maxWidth: '100%'
      }
    }
  })
)
